export default __webpack_public_path__ + "static/media/person.e024a50d.svg";